var map = {
	"./ContainerMountPaths.vue": 43809,
	"./Mount.vue": 78067,
	"./awsElasticBlockStore.vue": 7190,
	"./azureDisk.vue": 25648,
	"./azureFile.vue": 90228,
	"./emptyDir.vue": 41193,
	"./gcePersistentDisk.vue": 66301,
	"./hostPath.vue": 90642,
	"./index.vue": 61959,
	"./nfs.vue": 87893,
	"./secret.vue": 803,
	"./vsphereVolume.vue": 88216,
	"edit/workload/storage/ContainerMountPaths.vue": 43809,
	"edit/workload/storage/Mount.vue": 78067,
	"edit/workload/storage/awsElasticBlockStore.vue": 7190,
	"edit/workload/storage/azureDisk.vue": 25648,
	"edit/workload/storage/azureFile.vue": 90228,
	"edit/workload/storage/emptyDir.vue": 41193,
	"edit/workload/storage/gcePersistentDisk.vue": 66301,
	"edit/workload/storage/hostPath.vue": 90642,
	"edit/workload/storage/index.vue": 61959,
	"edit/workload/storage/nfs.vue": 87893,
	"edit/workload/storage/secret.vue": 803,
	"edit/workload/storage/vsphereVolume.vue": 88216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68219;